export default "__VITE_ASSET__CbCNScup__"